"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2515],{

/***/ 82515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ AboutSection; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);
/* harmony import */ var _Title__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79245);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53156);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67720);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87357);
/* harmony import */ var styles_jss_Home_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47728);
/* harmony import */ var styles_jss_Layout_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48231);
/* harmony import */ var utils_helperFunction__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18991);
/* harmony import */ var _NextImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68164);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58731);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);










function AboutSection(param) {
    var about = param.about;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)([
        "homePage"
    ]).t;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)().locale;
    var btn_url = about.btn_url, description = about.description, items = about.items;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(styles_jss_Home_styles__WEBPACK_IMPORTED_MODULE_1__/* .AboutWrapper */ .II, {
        style: {
            background: "url(/images/about_section-home.png) no-repeat center center / cover "
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_Title__WEBPACK_IMPORTED_MODULE_0__/* .MainTitle */ .U3, {
                    textAlign: "left",
                    children: t("about-title")
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_Title__WEBPACK_IMPORTED_MODULE_0__/* .MainSubTitle */ ._P, {
                    textAlign: "left",
                    children: description
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(styles_jss_Layout_styles__WEBPACK_IMPORTED_MODULE_2__/* .PrimaryButton */ .KM, {
                    className: "read-more",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                        href: btn_url,
                        children: t("read-more")
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    variant: "middle",
                    sx: {
                        my: "50px",
                        mx: "0"
                    }
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                    container: true,
                    rowSpacing: {
                        xs: 7.5
                    },
                    columnSpacing: {
                        xs: 0,
                        sm: 7
                    },
                    children: items.map(function(item) {
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                            item: true,
                            xs: 12,
                            md: 6,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                container: true,
                                columnSpacing: {
                                    xs: 0,
                                    sm: 3
                                },
                                rowSpacing: {
                                    xs: 3,
                                    sm: 0
                                },
                                className: "aboutBoxInfo",
                                alignItems: "center",
                                justifyContent: "center",
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                        item: true,
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                            className: "imageWrapper",
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_NextImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                src: item.img.data.attributes.formats.thumbnail.url,
                                                alt: item.title,
                                                layout: "fill",
                                                objectFit: "cover",
                                                placeholder: "blur"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                        item: true,
                                        xs: 12,
                                        sm: true,
                                        className: "content",
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                                                href: item.btn_url || "#",
                                                locale: locale,
                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("h3", {
                                                        className: "title",
                                                        children: item.title
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("p", {
                                                className: "text",
                                                children: (0,utils_helperFunction__WEBPACK_IMPORTED_MODULE_3__/* .truncateString */ .aS)(item.description, 150)
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, item.id);
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 79245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_P": function() { return /* reexport */ MainSubTitle; },
  "U3": function() { return /* reexport */ MainTitle; },
  "ll": function() { return /* reexport */ SecondSubTitle; },
  "oK": function() { return /* reexport */ SecondTitle; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./styles/jss/Layout.styles.js
var Layout_styles = __webpack_require__(48231);
;// CONCATENATED MODULE: ./components/Title/MainTitle.jsx


function MainTitle(param) {
    var children = param.children, className = param.className, color = param.color, textAlign = param.textAlign;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layout_styles.H2, {
        className: className,
        color: color,
        textAlign: textAlign,
        children: children
    });
};

;// CONCATENATED MODULE: ./components/Title/MainSubTitle.jsx


function MainSubTitle(param) {
    var children = param.children, className = param.className, textAlign = param.textAlign, color = param.color;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layout_styles/* SubTitleParagraph */.G9, {
        className: className,
        textAlign: textAlign,
        color: color,
        children: children
    });
};

;// CONCATENATED MODULE: ./components/Title/SecondTitle.jsx


function SecondTitle(param) {
    var children = param.children, classname = param.classname;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layout_styles.H4, {
        className: classname,
        children: children
    });
};

;// CONCATENATED MODULE: ./components/Title/SecondSubTitle.jsx


function SecondSubTitle(param) {
    var children = param.children, classname = param.classname;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layout_styles/* SecondSubTitleParagraph */.Mp, {
        className: classname,
        children: children
    });
};

;// CONCATENATED MODULE: ./components/Title/index.jsx






/***/ })

}]);